"use strict";

exports.__esModule = true;
var _flattenAggregates = require("./flattenAggregates");
Object.keys(_flattenAggregates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flattenAggregates[key]) return;
  exports[key] = _flattenAggregates[key];
});
var _flattenMetrics = require("./flattenMetrics");
Object.keys(_flattenMetrics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flattenMetrics[key]) return;
  exports[key] = _flattenMetrics[key];
});